import React from 'react';
import { Profile } from '@/types/auth';
import { Quote } from 'lucide-react';

interface BioWidgetProps {
  profile: Profile;
}

export const BioWidget: React.FC<BioWidgetProps> = ({ profile }) => {
  if (!profile.bio && !profile.favorite_quote) {
    return (
      <div className="flex items-center justify-center h-full text-muted-foreground">
        <div className="text-center">
          <Quote className="h-8 w-8 mx-auto mb-2 opacity-50" />
          <p className="text-sm">No bio available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col gap-3">
      {profile.bio && (
        <div>
          <h3 className="text-sm font-medium text-muted-foreground mb-2">About</h3>
          <p className="text-sm leading-relaxed">{profile.bio}</p>
        </div>
      )}
      
      {profile.favorite_quote && (
        <div className="flex-1 flex items-end">
          <div className="relative">
            <Quote className="h-4 w-4 text-primary/40 absolute -top-2 -left-2" />
            <blockquote className="text-sm italic text-muted-foreground pl-4 border-l-2 border-primary/20">
              {profile.favorite_quote}
            </blockquote>
          </div>
        </div>
      )}
    </div>
  );
};